// Strings used in app

export const Strings = {
    welcomeBack: "Welcome Back",
    signin: "Sign in",
    forgetPassword:"Forget Password",
    emailAddress: "Email Address",
    password: "Password",
    forgotMyPassword: "Forgot my password?",
    dashboard: "Dashboard",
    invoices: "Invoices",
    customers: "Customers",
    shipping: "Shipping",
    inventory: "Inventory",
    logout: "Logout",
    newInvoice: "New Invoice",
    letLookAtWhatsHappening: "Let`s look at what`s happening!",
    search: "Search",
    earnings: 'Earnings',
    recentCalls: 'Recent Calls',
    orderFullFilled: 'Orders Full Filled',
    lowRawMaterials: 'Low Raw Materials',
    outOfStockItems: 'Out of Stock Items',
    billingInformation: "Billing Information",
    savedDrafts: "Saved Drafts",
    recentlyCompleted: "Recently Completed",
    pendingPayment: "Pending Payment",
    shippingInformation: "Shipping Information",
    products: "Products",
    shippingOptions: "Shipping Options",
  };
  